import WebNoPaymentMethodErrorDescription from "../../../../content/sdk/web/2.x.x/_common/errors/WebNoPaymentMethodErrorDescription.mdx";
import WebNoPaymentMethodErrorRecoverySuggestion from "../../../../content/sdk/web/2.x.x/_common/errors/WebNoPaymentMethodErrorRecoverySuggestion.mdx";
import PrimerTeardownErrorDescription from "../../../../content/sdk/web/2.x.x/_common/errors/PrimerTeardownErrorDescription.mdx";
import PrimerServerErrorDescription from "../../../../content/sdk/web/2.x.x/_common/errors/PrimerServerErrorDescription.mdx";
import TokenizationErrorDescription from "../../../../content/sdk/web/2.x.x/_common/errors/TokenizationErrorDescription.mdx";
import ValidationErrorDescription from "../../../../content/sdk/web/2.x.x/_common/errors/ValidationErrorDescription.mdx";
import PaymentCreationDisabledErrorDescription from "../../../../content/sdk/web/2.x.x/_common/errors/PaymentCreationDisabledErrorDescription.mdx";
import PaymentCreationDisabledErrorRecoverySuggestion from "../../../../content/sdk/web/2.x.x/_common/errors/PaymentCreationDisabledErrorRecoverySuggestion.mdx";
import HeadlessVaultManagerValidationErrorDescription from "../../../../content/sdk/web/2.x.x/_common/errors/HeadlessVaultManagerValidationErrorDescription.mdx";
import * as React from 'react';
export default {
  WebNoPaymentMethodErrorDescription,
  WebNoPaymentMethodErrorRecoverySuggestion,
  PrimerTeardownErrorDescription,
  PrimerServerErrorDescription,
  TokenizationErrorDescription,
  ValidationErrorDescription,
  PaymentCreationDisabledErrorDescription,
  PaymentCreationDisabledErrorRecoverySuggestion,
  HeadlessVaultManagerValidationErrorDescription,
  React
};